import * as yup from 'yup';

export const socialNetworks = [
  { value: '', display: 'Social Network' },
  { value: 'facebook', display: 'Facebook' },
  { value: 'instagram', display: 'Instagram' },
  { value: 'twitter', display: '𝕏' },
  { value: 'linkedin', display: 'LinkedIn' },
  { value: 'youtube', display: 'Youtube' },
  { value: 'pinterest', display: 'Pinterest' },
  { value: 'ebay', display: 'eBay' },
  { display: 'Aboutme', value: 'aboutme' },
  { display: 'Badoo', value: 'badoo' },
  { display: 'Bebo', value: 'bebo' },
  { display: 'Classmates', value: 'classmates' },
  { display: 'CPF', value: 'cpf' },
  { display: 'Cyworld', value: 'cyworld' },
  { display: 'Delicious', value: 'delicious' },
  { display: 'Deviantart', value: 'deviantart' },
  { display: 'Diggtagged', value: 'diggtagged' },
  { display: 'Douban', value: 'douban' },
  { display: 'Flavorsme', value: 'flavorsme' },
  { display: 'Flickr', value: 'flickr' },
  { display: 'Flixster', value: 'flixster' },
  { display: 'Foursquare', value: 'foursquare' },
  { display: 'Freelancer', value: 'freelancer' },
  { display: 'Friendster', value: 'friendster' },
  { display: 'Gaia', value: 'gaia' },
  { display: 'Github', value: 'github' },
  { display: 'Goodreads', value: 'goodreads' },
  { display: 'Google', value: 'google' },
  { display: 'Gravatar', value: 'gravatar' },
  { display: 'Habbo', value: 'habbo' },
  { display: 'Hi5', value: 'hi5' },
  { display: 'Hyves', value: 'hyves' },
  { display: 'Imgur', value: 'imgur' },
  { display: 'Lastfm', value: 'lastfm' },
  { display: 'Livejournal', value: 'livejournal' },
  { display: 'Meetup', value: 'meetup' },
  { display: 'Myheritage', value: 'myheritage' },
  { display: 'Mylife', value: 'mylife' },
  { display: 'Myspace', value: 'myspace' },
  { display: 'Myyearbook', value: 'myyearbook' },
  { display: 'Netlog', value: 'netlog' },
  { display: 'Ning', value: 'ning' },
  { display: 'Odnoklassniki', value: 'odnoklassniki' },
  { display: 'Orkut', value: 'orkut' },
  { display: 'Quora', value: 'quora' },
  { display: 'Qzone', value: 'qzone' },
  { display: 'Renren', value: 'renren' },
  { display: 'Sonico', value: 'sonico' },
  { display: 'Soundcloud', value: 'soundcloud' },
  { display: 'Stumbleupon', value: 'stumbleupon' },
  { display: 'Tumblr', value: 'tumblr' },
  { display: 'Viadeo', value: 'viadeo' },
  { display: 'Vkontakte', value: 'vkontakte' },
  { display: 'Weeworld', value: 'weeworld' },
  { display: 'Xanga', value: 'xanga' },
  { display: 'Xing', value: 'xing' },
  { display: 'Yelp', value: 'yelp' },
];

export const schemaUsernameSearchForm = yup.object({
  username: yup
    .string()
    .required('Please enter a valid username to complete search.')
    .trim(),
});
